export class Pair<TCode = string, TName = string> {
  public code: TCode;
  public name: TName;

  public constructor(code: TCode, name: TName) {
    this.code = code;
    this.name = name;
  }
}
